import { useMutation } from 'react-query';

import { finalProject } from 'shared/api/projects/http';

const useMutateFinalProject = (options = undefined) => useMutation((id) => finalProject(id), options);

export default useMutateFinalProject;
